export default __webpack_public_path__ + "img/8ce10afd93f38752a8637492c8703073.svg";